import React, { useRef } from "react";
import styles from "./DropdownStyles.module.css";
import { Dropdown } from "react-bootstrap";
import { getQuestionAndAnswerInText } from "../../utils";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action/index";
import { markUnmarkFavourite, getQuestionDraftData,deleteAnswerrecord, fetchAttachmentURL } from "../../API/api";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    style={{ textDecoration: "none", color: "#a9a9a9" }}
  >
    {children}
    <span>
      <i
        className="fa fa-ellipsis-v"
        style={{ fontSize: "20px", color: "lightgray" }}
      ></i>
    </span>
  </a>
));


const DropdownComponent = ({ question }) => {
  // console.log("question",question)
  const currentPath = useLocation();
  const dispatch = useDispatch();
  const { filteredOrigSearchData, advanceFilterModalToggle, getSelectedQuestion, markedTrendingData , markedAnsweredData, markedFavData, markedSharedByData, markedSharedWithData, updateKeyTagData, questionDataForEditor, updateAnswerTextForEditor, updateSubmissionTypeForEditor, updateAttachmentForEditor, updateCheckBoxValForEditor, filteringSearchData,getSeekerAttachment} =
    bindActionCreators(Actions, dispatch);
  const searchState = useSelector((state) => state.search);
  const userState = useSelector((state) => state.user);
  const trendingState = useSelector((state) => state.trending);
  const answeredState = useSelector((state) => state.answeredQuestions);
  const favouriteState = useSelector((state) => state.favouriteQuestions);
  const sharedByState = useSelector((state) => state.sharedBy);
  const sharedWithState = useSelector((state) => state.sharedWith);
  const tagState = useSelector((state) => state.keyTag);
  const editorState = useSelector((state)=> state.editor);
  const inlineImageState = useSelector((state) => state.domain);

  const copyQA = () => {
    let data = getQuestionAndAnswerInText(question);
    var validHTMLTagsTextArea =
      /<(abbr|acronym|address|applet|area|article|aside|audio|b|base|basefont|bdi|bdo|bgsound|big|blink|blockquote|body|br|button|canvas|caption|center|cite|code|col|colgroup|data|datalist|dd|del|details|dfn|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hgroup|hr|html|i|iframe|img|input|ins|isindex|kbd|keygen|label|legend|link|listing|main|map|mark|marquee|menu|menuitem|meta|meter|nav|nobr|noframes|noscript|object|optgroup|option|output|p|param|plaintext|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|source|spacer|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|var|video|wbr|xmp|\/abbr|\/acronym|\/address|\/applet|\/area|\/article|\/aside|\/audio|\/b|\/base|\/basefont|\/bdi|\/bdo|\/bgsound|\/big|\/blink|\/blockquote|\/body|\/br|\/button|\/canvas|\/caption|\/center|\/cite|\/code|\/col|\/colgroup|\/data|\/datalist|\/dd|\/del|\/details|\/dfn|\/dir|\/div|\/dt|\/em|\/embed|\/fieldset|\/figcaption|\/figure|\/font|\/footer|\/form|\/frame|\/frameset|\/h1|\/h2|\/h3|\/h4|\/h5|\/h6|\/head|\/header|\/hgroup|\/hr|\/html|\/i|\/iframe|\/img|\/input|\/ins|\/isindex|\/kbd|\/keygen|\/label|\/legend|\/link|\/listing|\/main|\/map|\/mark|\/marquee|\/menu|\/menuitem|\/meta|\/meter|\/nav|\/nobr|\/noframes|\/noscript|\/object|\/optgroup|\/option|\/output|\/p|\/param|\/plaintext|\/pre|\/progress|\/q|\/rp|\/rt|\/ruby|\/s|\/samp|\/script|\/section|\/select|\/small|\/source|\/spacer|\/span|\/strike|\/strong|\/style|\/sub|\/summary|\/sup|\/table|\/tbody|\/td|\/textarea|\/tfoot|\/th|\/thead|\/time|\/title|\/tr|\/track|\/tt|\/u|\/var|\/video|\/wbr|\/xmp)[^>]{0,}>/gim;
    data = data.replace(validHTMLTagsTextArea, " ");
    data = data.replace(/style=".*?"/gi, "");
    window.navigator.clipboard.writeText(data);
    toast.success("Copied!", {
      position: toast.POSITION.TOP_RIGHT,
      style:{
        width:'300px',
        height:'20px',
        // marginLeft:'120px',
        fontSize:'12px'
      },
    });
  };

  const convertStringToEpoch = (dt) =>{
    let date = Date.parse(dt);
    return date;
  }
  const isAnsweredByMe = (arr) =>{
    let id = ""
    arr.filter(obj=>{
      if(obj.expertUuid === userState.geoAttributes.userId){
        updateCheckBoxValForEditor({flag:obj.internal,key:"internal"});
        updateCheckBoxValForEditor({flag:obj.privacy,key:"isUpdateKB"});
        id = obj.answerUuid;
      }
    })
    return id;
  }

  const isAnsweredByMeAttachment = (arr) =>{
    let text = []
    arr.filter(obj=>{
      if(obj.expertUuid === userState.geoAttributes.userId){
        text = obj.attachments;
      }
    })
    return text;
  }
  const isAnsweredByMeLabel = (arr) =>{
    let text = 'Add'
    arr.filter(obj=>{
      if(obj.expertUuid === userState.geoAttributes.userId){
        text = 'Edit';
      }
    })
    return text;
  }
  const navigate = useNavigate();

  const successfulDeleteQuestion = (message) => {
    return(
      <span style={{fontSize:'12px'}}>{message}</span>
    )
  }

  const deleteAnswer = () =>{
    let answerUuid = question.answers.map(data=>{
      if(data.expertUuid === userState.geoAttributes.userId){
        return data.answerUuid;
      }
    })
    let updatedData = answeredState.data = answeredState.data.filter(obj=>{
      if(obj.questionUuid !== question.questionUuid){
        return obj;
      }
    });
    let id =(arr)=>{
      let uuid ="";
      arr.filter(ids=>{
        if(ids !== undefined){
          uuid = ids;
        }
      })
      return uuid;
    }
    deleteAnswerrecord(id(answerUuid)).then(res=>{
      if (res===undefined) return;
      if(res.data.success){
        toast.success(successfulDeleteQuestion(res.data.message), {
          position: toast.POSITION.TOP_RIGHT
        });
      }
      markedAnsweredData(updatedData);
    })
    
  }

  const appendInlineImageInText = async (arr) =>{
    let newArr = await arr.filter(obj=>{
      if(obj.expertUuid === userState.geoAttributes.userId){
        if(obj.inlineImages.length > 0){
          for (let i = 0; i < obj.inlineImages.length; ++i) {
            let pld= {name: obj.inlineImages[i]}
            fetchAttachmentURL(pld).then(res=>{
              if (res===undefined) return;
              if (obj.inlineImages[i].includes(".png")) {
              } else {
                let imgTag = `<img style='max-width:50%' src=${
                  res.data.data.src
                }></img>`;
  
                let replacedContent = obj.inlineImages[i];
                obj.answerCopy = obj.answerCopy.replaceAll(
                  replacedContent,
                  imgTag
                );
                updateAnswerTextForEditor(obj.answerCopy);
              }
            })
          }
        }
        
        return obj;
      }
    })
    updateAnswerTextForEditor(newArr.length === 0?"":newArr[0].answerCopy);
  }
  const editAnswer = ()=>{
    // console.log("question",question)
    let data = question;
    if(data.questionText === undefined){
      data.questionText = data.question;
    }
    if(currentPath.pathname.includes('/search')){
      data.questionUuid = data.origQuestionUuid;
    }
    if (data.seekerAttachments && data.seekerAttachments !== null) {
      getSeekerAttachment(data.seekerAttachments)
    }
    updateAttachmentForEditor(isAnsweredByMeAttachment(data.answers))
    let isAnswerUuid = isAnsweredByMe(data.answers);
    editorState.answerUuid = isAnsweredByMe(data.answers);
    updateSubmissionTypeForEditor(isAnswerUuid === ''?'answer':'update');
    data.questionPostedTimestamp = data.questionPostedTimestamp === undefined ?data.postedTimestamp:data.questionPostedTimestamp;
    data.questionStatus = 'answered';
    data.questionPostedTimestamp = typeof(data.questionPostedTimestamp)==='string'?convertStringToEpoch(data.questionPostedTimestamp):data.questionPostedTimestamp;
    questionDataForEditor(data);
      getQuestionDraftData(data.questionUuid).then(res=>{
        if (res===undefined) return;
        if(res.data.data.length > 0){
          updateAnswerTextForEditor(res.data.data[0].answer);
        }else{
          appendInlineImageInText(data.answers);
        }
      })
    navigate('/expertHome/editor');
  }
  
  const updateFavouriteData = (data) =>{
    // if(currentPath.pathname.includes('/search')){
    //   updateSearchData(data);
    // }
    if(currentPath.pathname.includes('/trending')){
      markedTrendingData(data)
    }
    if(currentPath.pathname.includes('/answered')){
      markedAnsweredData(data)
    }
    if(currentPath.pathname.includes('/favourite')){
      markedFavData(data)
    }
    if(currentPath.pathname.includes('/sharedby')){
      markedSharedByData(data)
    }
    if(currentPath.pathname.includes('/sharedwith')){
      markedSharedWithData(data)
    }
    if(currentPath.pathname.includes('/tagdata')){
      updateKeyTagData(data)
    }
  }
  const onClickFavorite = (flag) => {
    let filteredData = [];
    let filteredData2 = []
    if(currentPath.pathname.includes('/search')){
    filteredData = searchState.origSearchData.filter((data) => {
      if (data.questionUuid === question.questionUuid) {
        data.favourite = !flag;
      }
      return data;
    });
    filteredData2 = searchState.searchData.filter((data) => {
      if (data.questionUuid === question.questionUuid) {
        data.favourite = !flag;
      }
      return data;
    });
  }
  if(currentPath.pathname.includes('/trending')){
    filteredData = trendingState.data.filter((data) => {
      if (data.questionUuid === question.questionUuid) {
        data.favourite = !flag;
      }
      return data;
    });
  } 
  if(currentPath.pathname.includes('/answered')){
    filteredData = answeredState.data.filter((data) => {
      if (data.questionUuid === question.questionUuid) {
        data.favourite = !flag;
      }
      return data;
    });
  }
  if(currentPath.pathname.includes('/favourite')){
    filteredData = favouriteState.data.filter((data) => {
      if (data.questionUuid === question.questionUuid) {
        data.favourite = !flag;
      }
      return data;
    });
  }
  if(currentPath.pathname.includes('/sharedby')){
    filteredData = sharedByState.data.filter((data) => {
      if (data.questionUuid === question.questionUuid) {
        data.favourite = !flag;
      }
      return data;
    });
    
  }

  if(currentPath.pathname.includes('/sharedwith')){
    filteredData = sharedWithState.data.filter((data) => {
      if (data.questionUuid === question.questionUuid) {
        data.favourite = !flag;
      }
      return data;
    });
    
  }

  if(currentPath.pathname.includes('/tagdata')){
    filteredData = tagState.data.filter((data) => {
      if (data.questionUuid === question.questionUuid) {
        data.favourite = !flag;
      }
      return data;
    });
    
  }
    markUnmarkFavourite(question.origQuestionUuid)
      .then((res) => {
        if(currentPath.pathname.includes('/search')){
          filteredOrigSearchData(filteredData);
          filteringSearchData(filteredData2);
        }
        else{
        updateFavouriteData(filteredData)
        }
      })
      .catch((err) => {});
  };

  const onClickShareButton = () => {
    advanceFilterModalToggle({ bool: true, value: "shareQuestion" });
    getSelectedQuestion(question);
  };
  return (
    <Dropdown autoClose="outside">
      <Dropdown.Toggle as={CustomToggle} id="dropdown-autoclose-outside" />
      <Dropdown.Menu size="sm">
      {(currentPath.pathname.includes('/expertHome/search') || currentPath.pathname.includes('/expertHome/tagdata') || currentPath.pathname.includes('/expertHome/trending') || currentPath.pathname.includes('/expertHome/answered')) && <Dropdown.Item style={{ fontSize: "12px" }} onClick={() => editAnswer()}>
          <i
            className="fa fa-edit"
            style={{ paddingRight: "5px", color: "#a9a9a9" }}
          ></i>
          {isAnsweredByMeLabel(question.answers)}
        </Dropdown.Item>}
        {(currentPath.pathname.includes('/expertHome/search') || currentPath.pathname.includes('/expertHome/tagdata') ||currentPath.pathname.includes('/expertHome/trending') || currentPath.pathname.includes('/expertHome/answered')) &&  <Dropdown.Divider />}
        {currentPath.pathname.includes('/expertHome/answered') && <Dropdown.Item style={{ fontSize: "12px" }} onClick={() => deleteAnswer()}>
          <i
            className="fa fa-trash"
            style={{ paddingRight: "5px", color: "#a9a9a9" }}
          ></i>
          Delete
        </Dropdown.Item>}
        {currentPath.pathname.includes('/expertHome/answered')&&  <Dropdown.Divider />}
        <Dropdown.Item style={{ fontSize: "12px" }} onClick={() => copyQA()}>
          <i
            className="fa fa-clipboard"
            style={{ paddingRight: "5px", color: "#a9a9a9" }}
          ></i>
          Copy
        </Dropdown.Item>
        <Dropdown.Divider />
        {!currentPath.pathname.includes('/sharedwith') && <Dropdown.Item
          style={{ fontSize: "12px" }}
          onClick={() => onClickShareButton()}
        >
          <i
            className="fa fa-share-alt"
            style={{
              paddingRight: "5px",
              color: `${
                question.sharedWith && question.sharedWith.length > 0
                  ? "green"
                  : "#a9a9a9"
              }`,
            }}
          ></i>
          Share
        </Dropdown.Item>}
        {!currentPath.pathname.includes('/sharedwith') && <Dropdown.Divider />}
        <Dropdown.Item
          style={{ fontSize: "12px" }}
          onClick={() => onClickFavorite(question.favourite)}
        >
          <i
            className={`fa fa-heart ${
              question.favourite
                ? styles.dropdownFavoriteSelected
                : styles.dropdownFavorite
            }`}
          ></i>
          Favorite
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropdownComponent;
